export class CallbacksConfig {
    constructor(options) {
        this.onAirportHover = options.onAirportHover;
        this.onAirportClick = options.onAirportClick;
        this.onFlightHover = options.onFlightHover;
        this.onFlightClick = options.onFlightClick;
    }
}
